import { render } from "./SpecialPageColumn.vue?vue&type=template&id=a5e658e4&scoped=true&ts=true"
import script from "./SpecialPageColumn.vue?vue&type=script&lang=ts"
export * from "./SpecialPageColumn.vue?vue&type=script&lang=ts"

import "./SpecialPageColumn.vue?vue&type=style&index=0&id=a5e658e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e658e4"]])

export default __exports__